import React from "react";


const Header = () => {
    return <div className="container-header-appointment">
        <div className="container-header-logo">
            <a href="https://www.temptation.it">
                <img className="logo-image" src="/calendario-appuntamenti/images/LOGO-SITO-2024-2.png" />
            </a>
        </div>
    </div>
}

export default Header